//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, ContentTypeGroup } from '@constants'
import _ from 'lodash'
import polling from '~/mixins/poll-when-visible'

const DAY_OVERVIEW_ARTICLES = gql`
  query DAY_OVERVIEW_ARTICLES($first: Int, $where: ArticleFilterInput, $order: [ArticleSortInput!]) {
    articles(first: $first, where: $where, order: $order) {
      nodes {
        id
        externalId
        title
        slug
        date
        contentType {
          id
          name
          contentTypeGroup {
            id
            name
          }
        }
      }
    }
  }
`

export default {
  mixins: [polling],
  data() {
    return { columns: [], total: 75, perColumn: 25, hasFetched: false }
  },
  computed: {
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    canShow() {
      return typeof navigator !== 'undefined' && !navigator.userAgent.includes('Chrome-Lighthouse')
    }
  },
  watch: {
    async languageId() {
      // don't fetch until the component has actually scrolled into view once
      if (!this.hasFetched) return
      await this.refresh(true)
    }
  },
  methods: {
    // fired once by <lazy-component> when it first scrolls into view; this is what
    // gates the initial fetch and the 5-minute poll, instead of firing on mount
    async onIntersected() {
      if (!this.canShow || this.hasFetched) return
      this.hasFetched = true

      this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
      await this.refresh(true)
      this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)

      this.startPolling(() => this.refresh(true), 5 * 60 * 1000)
    },
    async refresh(purge = false) {
      const where = {
        contentType: {
          contentTypeGroupId: {
            neq: ContentTypeGroup.PARTNER_CONTENT
          }
        }
      }

      if (this.languageId != null) {
        where.languageId = {
          eq: this.languageId
        }
      }

      try {
        const { data } = await this.$apollo.query({
          query: DAY_OVERVIEW_ARTICLES,
          variables: {
            first: this.total,
            where,
            order: [
              {
                date: 'DESC'
              }
            ]
          },
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        this.columns = []

        const dayOverviewArticles = data.articles.nodes

        const articlesByDates = _(dayOverviewArticles)
          .groupBy((article) => {
            return this.$dayjs(article.date).startOf('date').valueOf()
          })
          .toPairs()
          .sortBy((kvArray) => kvArray[0])
          .reverse()
          .map((kvArray) => kvArray[1])
          .value()

        const constructArticles = (articles, leftArticles = [], forceAdd = false) => {
          let mainHeader = ''
          let additionalColumn = 0

          if (leftArticles.length > 0) {
            articles.splice(0, 0, { header: getHeader(this.$dayjs(articles[0].date)) })
            articles = leftArticles.concat(articles)
            additionalColumn = 1
          }

          // if articles are greater than this.perColumn (which is good for 1 column)
          if (articles.length >= this.perColumn) {
            // for first column, set the header based on the date of first article
            if (this.columns.length === 0) {
              mainHeader = getHeader(articles[0].date)
            } else {
              // succeeding column will based on the last article added in previous column and first article for this column
              const firstColumnLastArticle =
                this.columns[this.columns.length - 1].articles[
                  this.columns[this.columns.length - 1].articles.length - 1
                ]

              if (!this.$dayjs(firstColumnLastArticle.date).isSame(this.$dayjs(articles[0].date), 'date')) {
                mainHeader = getHeader(this.$dayjs(articles[0].date))
              }
            }

            this.columns.push({
              articles: articles.splice(0, this.perColumn + additionalColumn),
              mainHeader
            })
          }

          if (forceAdd) {
            this.columns.push({
              articles: articles.splice(0, this.perColumn + additionalColumn),
              mainHeader
            })
          }

          // check again if it can still fit a 1 column
          if (articles.length >= this.perColumn) {
            return constructArticles(articles)
          } else {
            return articles
          }
        }

        const todayDate = this.$dayjs().startOf('date')
        const yesterdayDate = this.$dayjs().subtract(1, 'day').startOf('date')

        const getHeader = (date) => {
          if (this.isBetweenDates(todayDate, date)) {
            return this.$t('day_overview.today')
          } else if (this.isBetweenDates(yesterdayDate, date)) {
            return this.$t('day_overview.yesterday')
          } else {
            const week = this.$dayjs(date).week()
            if (todayDate.week() === week) {
              // current week, show day name
              const weekday = this.$dayjs(date).isoWeekday()
              return this.$t(`day_overview.${weekday}`)
            } else if (todayDate.week() - 1 === week) {
              // last week, show last + day name
              const weekday = this.$dayjs(date).isoWeekday()
              return `${this.$t(`day_overview.last`)} ${this.$t(`day_overview.${weekday}`)}`
            } else {
              // before last week, show date
              return this.formatDate(date)
            }
          }
        }

        let leftArticles = []
        for (const articles of articlesByDates) {
          if (this.canAddColumn()) {
            leftArticles = constructArticles(articles, leftArticles)
          }
        }

        if (this.canAddColumn() && leftArticles.length > 0) {
          constructArticles([], leftArticles, true)
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    isBetweenDates(date, comparedDate) {
      const start = date.startOf('date')
      const end = date.endOf('date')

      return this.$dayjs(comparedDate).isBetween(start, end)
    },

    canAddColumn() {
      return this.columns.length < 3
    }
  }
}
